import React from 'react';
import type {SxProps} from '@mui/material';
import type {IconName} from 'components/icons/types';
import type {SystemHealthStatus} from 'services/healthcheck/types';
import {px2rem} from 'theme';
import {Icon} from 'components/icons';
import {FlexBox} from 'components/layout';

type Size = 'small' | 'medium' | 'large';
type Props = {
  status: SystemHealthStatus;
  size?: Size;
  icon?: IconName;
};

const indicatorSmallSx: SxProps = {
  width: `${px2rem(7)}`,
  height: `${px2rem(7)}`,
  borderRadius: '50%',
  transition: 'background-color 0.3s ease-in-out!important',
};

const indicatorMediumSx: SxProps = {
  width: `${px2rem(17)}`,
  height: `${px2rem(17)}`,
  borderRadius: '50%',
  transition: 'background-color 0.3s ease-in-out!important',
};

const indicatorLargeSx: SxProps = {
  width: `${px2rem(24)}`,
  height: `${px2rem(24)}`,
  borderRadius: '50%',
  transition: 'background-color 0.3s ease-in-out!important',
};

// TODO: Use from ColorPalette when move to work has been merged
const greenSx: SxProps = {
  backgroundColor: '#A5CE90',
};

const yellowSx: SxProps = {
  backgroundColor: '#FFBD12',
};

const redSx: SxProps = {
  backgroundColor: '#AD4F49',
};

const healthSxMap: Record<SystemHealthStatus, Record<Size, SxProps>> = {
  green: {
    small: {...indicatorSmallSx, ...greenSx},
    medium: {...indicatorMediumSx, ...greenSx},
    large: {...indicatorLargeSx, ...greenSx},
  },
  yellow: {
    small: {...indicatorSmallSx, ...yellowSx},
    medium: {...indicatorMediumSx, ...yellowSx},
    large: {...indicatorLargeSx, ...yellowSx},
  },
  red: {
    small: {...indicatorSmallSx, ...redSx},
    medium: {...indicatorMediumSx, ...redSx},
    large: {...indicatorLargeSx, ...redSx},
  },
};

export const HealthIndicator: React.FC<Props> = ({status, size = 'small'}) => {
  const sx = healthSxMap[status][size];
  const icon = status === 'green' || size === 'small' ? undefined : 'Info';
  return (
    <FlexBox sx={sx} center>
      {icon ? (
        <Icon
          icon={icon}
          fontSize={size}
          color={status === 'yellow' ? 'primary' : undefined}
        />
      ) : null}
    </FlexBox>
  );
};
